import api from '@/api';

import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

//     namespaced: true,

const state = {
    username: Vue.$cookies.isKey('username') ? Vue.$cookies.get('username') : '',
    password: '',
    loading: false,
    userId: null,
    orgId: null,
    fflag: null,        // флаги user-a
    online: false,
    error: false,
    isEnterMode: true,  // true - ввод заявок, false - просмотр
    isIndividual: null,  // true - индивидуальный пользователь, false - групповой пользователь
}

const getters = {
    noCamera: () => {
        return window.__env.noCamera
    },

    account: (state) => {
        return state
    },

    apiService: (state) => {
        return state.apiService
    },

    username: (state) => {
        return state.username
    },

    password: (state) => {
        return state.password
    },

    loading: (state) => {
        return state.loading
    },

    userId: (state) => {
        return state.userId
    },

    orgId: (state) => {
        return state.orgId
    },

    fflag: (state) => {
        return state.fflag
    },

    online: (state) => {
        return state.online
    },

    error: (state) => {
        return state.error
    },

    isEnterMode: (state) => {
        return state.isEnterMode
    },

    isIndividual: (state) => {
        return state.isIndividual
    },

}

const actions = {

    async Login({ commit }, params) {
        const LoginResult = await api.login(params.username, params.password)

        if (LoginResult.result !== null) {
            commit('setUserName', params.username)
            commit('setUserId', LoginResult.result.userId)
            commit('setOrgId', LoginResult.result.orgId)
            commit('setFflag', LoginResult.result.fflag)
        }

        return LoginResult;
    },

    async Logoff({ commit }) {
        const logoffResult = await api.logoff();

        if (logoffResult.result) {
            commit('setOnline', false);
            commit('setUserId', null);
            commit('setOrgId', null);
            commit('setFflag', null);
            commit('setPassword', '');
        }

        return logoffResult;
    },

    async SetOnline({ commit }, params) {
        if (params)
            commit('setOnline', params)
    },

    CheckCard(commit, cardId) {
        return api.checkCard(state.userId, cardId)
    },

    StartLoading({ commit }) {
        commit('setLoading', true)
    },

    StopLoading({ commit } ) {
        commit('setLoading', false)
    },

    SetEnterMode({ commit }, isEnterMode ) {
        commit('setEnterMode', isEnterMode)
    },

}


const mutations = {
    // setApiService(state, apiService) {
    //     state.apiService = apiService
    // },

    setUserName(state, username) {
        state.username = username;
        Vue.$cookies.set('username', username, -1); // -1 - set never expire cookie
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    setUserId(state, userId) {
        state.userId = userId;
    },

    setOrgId(state, orgId) {
        state.orgId = orgId;
    },

    setFflag(state, fflag) {
        state.fflag = fflag;
        // console.log(parseInt(fflag, 0) & 32768)
        if (fflag) 
            state.isIndividual = (parseInt(fflag, 0) & 32768) !== 0
        else
            state.isIndividual = null
    },

    setPassword(state, password) {
        state.password = password
    },

    setOnline(state, online) {
        state.online = online
    },

    setEnterMode(state, isEnterMode) {
        state.isEnterMode = isEnterMode
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}